import React, { useRef, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { type Root } from 'react-dom/client';
import ReactImageZoom from 'react-image-zoom';

type ZoomImageIsolatedProps = {
  width: number;
  height: number;
  img: string;
  scale: number;
  zoomPosition: string;
  alt: string;
  className: string;
}

// Diese Komponente wird OHNE Strict Mode gerendert
const ZoomImageIsolated: React.FC<ZoomImageIsolatedProps> = (props) => {
  return <ReactImageZoom {...props} />;
};

const ZoomImageContainer = ({ zoomProps }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rootRef = useRef<Root | null>(null);

  useEffect(() => {
    if (containerRef.current && !rootRef.current) {
      // Erstelle Root OHNE Strict Mode
      rootRef.current = createRoot(containerRef.current);
      rootRef.current.render(<ZoomImageIsolated {...zoomProps} />);
    }

    return () => {
      // Cleanup beim Unmount
      if (rootRef.current) {
        rootRef.current.unmount();
        rootRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    // Update Props wenn sie sich ändern
    if (rootRef.current) {
      rootRef.current.render(<ZoomImageIsolated {...zoomProps} />);
    }
  }, [zoomProps]);

  return <div ref={containerRef} />;
};

export default ZoomImageContainer;